
















import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { getAreaCache } from "@/utils/httpUtils";

@Component({
  components: {},
})
export default class Home extends Vue {
  @State("aid") public aid!: string;
  act_rule = "";

  async mounted() {
    let area = await getAreaCache(this.aid);
    this.act_rule = area.act_rule;
  }
  goBack() {
    this.$router.back();
  }
}
